import React from 'react';

function titleCase(str: string) {
    if (str) {
        return str.trim().toLowerCase().split(' ').map(function (word: string) {
            return word.replace(word[0], word[0].toUpperCase());
        }).join(' ');
    } else {
        return str;
    }
}

export default function PortfolioGridCell(cellData: any) {
    const id = cellData.data.id;
    var href = "";
    var cellText = "";

    if (cellData.column.name == "shortInstitution") {
        href = '/grantdetails/' + id;
        if (cellData.data.institution === cellData.data.shortInstitution) //TODO temp fix to allow short institution override to display intended case
            cellText = titleCase(cellData.data.shortInstitution);
        else
            cellText = cellData.data.shortInstitution;

        return (
            <div>
                <a href={href}>{cellText}</a>
            </div>
        );
    } else if (cellData.column.name == "gms" || cellData.column.name == "po" || cellData.column.name == "pi" || cellData.column.name == "aor") {
        cellText = titleCase(cellData.value);

        return (
            cellText
        );
    }
};


